/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useContext, useState } from 'react';
import WatsonContext from '../../../context/WatsonContext';
import Button from '../../@base/Button';
import Checkbox from '../../@base/Checkbox';
import Datatable from '../../@base/DataTable';
import IntentDetail from './IntentDetail';
import { showRemoveConfirmation } from '../Commons';

import style from './Intent.module.css';

/** Componente de manutenção das intenções do Watson */
const Intents = (props) => {
  const context = useContext(WatsonContext);

  const [showIntentDetail, setShowIntentDetail] = useState(false);
  const [selectedIntent, setSelectedIntent] = useState(null);
  const [selectedIntentToDelete, setSelectedIntentToDelete] = useState([]);

  /** Muda o estado do componente para mostrar a visão detalhada da intent */
  const detailing = (intent) => {
    if (intent) setSelectedIntent(intent);
    else setSelectedIntent(null);
    setShowIntentDetail(true);
  };

  /** Muda o  estado do componente para voltar a visão de listagem */
  const closeDetail = () => {
    setSelectedIntent(null);
    setShowIntentDetail(false);
  };

  /** Manipula ação de remoção das intents selecionadas */
  const deleteIntentsHandler = (intents) => {
    const intentsToRemove = [].concat(intents);
    if (intentsToRemove.length > 0) setSelectedIntentToDelete(intentsToRemove);
  };

  /** Realiza remoção das intenções depois da confirmação  */
  const removeConfirmation = (selectedIntentToDeleteConfirmed) => {
    context.deleteIntentsOrEntities(
      'intents',
      [...selectedIntentToDeleteConfirmed],
      () => setSelectedIntentToDelete([]),
    );
  };

  /** Mostra a visão de listagem das intents */
  const showListView = () => {
    let intents = null;
    if (props.intents) {
      intents = Object.values(props.intents).map((intent) => (
        <tr key={intent.id}>
          <td>
            <Checkbox id={intent.name} />
          </td>
          <td
            onClick={() => detailing(intent)}
            onKeyPress={() => detailing(intent)}
            data-th="Intenção"
          >
            {intent.name}
          </td>
          <td
            onClick={() => detailing(intent)}
            onKeyPress={() => detailing(intent)}
            data-th="Descrição"
          >
            {intent.description}
          </td>
        </tr>
      ));
    }

    return (
      <Datatable
        classes={`${style.Datatable} ${style.ScrollDatable}`}
        deleteRows={deleteIntentsHandler}
        actionsItems={(
          <Button
            primary
            small
            classes={style.Button}
            onClick={() => detailing()}
          >
            <small>Adicionar intenção</small>
          </Button>
      )}
      >
        <table>
          <thead>
            <tr>
              <th scope="col" style={{ width: 60 }}>
                <Checkbox id="intent_check_all" />
              </th>
              <th scope="col" style={{ width: 200 }}>Intenção</th>
              <th scope="col">Descrição</th>
            </tr>
          </thead>
          <tbody>{intents}</tbody>
        </table>
      </Datatable>
    );
  };

  /** Mostra a visão de detalhe da intenção */
  const showDetailView = () => (
    <IntentDetail
      closeIntentDetail={closeDetail}
      selectedIntent={selectedIntent}
    />
  );

  return (
    <>
      {showRemoveConfirmation(
        selectedIntentToDelete,
        removeConfirmation,
        setSelectedIntentToDelete,
      )}
      {showIntentDetail ? showDetailView() : showListView()}
    </>
  );
};

export default Intents;
